import { Component, Input } from '@angular/core';

@Component({
  selector: 'pixie-story-block-item',
  templateUrl: './story-block-item.component.html',
  styleUrls: ['./story-block-item.component.scss']
})
export class StoryBlockItemComponent {

  @Input() item: any = {
    type: ''
  };

}
